<div class="constant-property-events">
  @if (dtp?.start && dtp?.end) {
    <label class="row" style="color:black;"><b>Time: </b>{{dtp.start  | stringDate}}
  - {{dtp.end  | stringDate}}</label>
}
<div class="comment-inner">
  <div style="display: flex;justify-content: flex-end;">
    <mat-paginator [length]="event_total" [pageSize]="page_size"
      [pageSizeOptions]="page_size_options.concat(event_total)"
      [pageIndex]="page_index"
      showFirstLastButtons
      (page)="pageData($event)"
      [disabled]="loading_next===true">
    </mat-paginator>
  </div>

  <div class="table-container" style="position:relative;">
    @if (dataSource!==undefined && dataSource.data.length > 0) {
      <table [dataSource]="dataSource"
        class="constant-property-events-table" mat-table
        >
        @for (column of columns; track column) {
          <!--Start-->
          @if (column==='start') {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell sticky>{{ column | upperfirst | removeUnderscore}}
              </th>
              <td *matCellDef="let event;" mat-cell sticky>
                {{event.attributes.start | stringDate}}
              </td>
            </ng-container>
          }
          <!--End-->
          @if (column==='end') {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell sticky>{{ column | upperfirst | removeUnderscore}}
              </th>
              <td *matCellDef="let event;" mat-cell sticky>
                {{event.attributes.end | stringDate}}
              </td>
            </ng-container>
          }
          <!--Constant Property-->
          @if (column===constant_property.attributes.name) {
            <ng-container matColumnDef="{{column}}">
              <th *matHeaderCellDef mat-header-cell sticky>{{ column | upperfirst | removeUnderscore}}
              </th>
              <td *matCellDef="let event;" mat-cell sticky
                [ngStyle]="{'text-align':constant_property.attributes.data_type==='float'?'right':'left'}">
                {{event.attributes.custom_constants[column]}}
              </td>
            </ng-container>
          }
        }
        <!--Row defs-->
        <tr *matHeaderRowDef="columns;" sticky mat-header-row></tr>
        <tr *matRowDef="let element; columns: columns;" mat-row>
        </tr>
      </table>
    }


    <div [ngStyle]="{'display': loading_next? 'flex' : 'none'}" class="app-loading">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>
</div>
